import React, { useEffect, useState } from 'react'

import { Row, Col, Button, Progress } from 'antd';

import './index.less';
import VideoView from '../../base/video';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import { t } from '../../../languages';
import PDFViewer from '../../base/pdfviewer';
import moment from 'moment';
// import BackMusic from '../../base/BackMusic';

const Theory = ({ lang, params, uid, eid, saveResult, handleCancel }) => {
    // console.log('Theory props:', props);
    const [initMoment, setInitMoment] = useState(0);

    const [ended, setEnded] = useState(false);

    const video = params.video;
    const videoUrl = video && video[lang] ? video[lang] : video;
    const text = params.text;
    const content = text ? t(lang, text.content).replace(/(?:\r\n|\r|\n)/g, '<br><br>') : null;
    const pdf = params.pdf;

    // console.log('Theory video:', video, videoUrl);

    useEffect(() => {
        setInitMoment(moment());
        return () => { };
    }, []);

    const handleAccept = () => {
        const coins = params.coins;
        const elapsedTime = moment().diff(initMoment, 'seconds');

        saveResult(uid, `${uid}-${eid}`, { id: 'T', uid, eid, p: 1, h: 1, e: 0, c: coins, r: [1], s: [1], et: elapsedTime });
        handleCancel();
    }

    return (
        <Row className="exercise">
            {/* <BackMusic source={'koto_9.mp3'} /> */}

            {window.cordova ? <ChangeOrientation to={'landscape'} /> : null}

            <Col span={21} className='progress-bar'>
                <Progress percent={0} showInfo={false} />
            </Col>

            <Col span={24} className="exercise-body">
                {text ? <section className="theory text">
                    <h2>{t(lang, text.title)}</h2>
                    <p dangerouslySetInnerHTML={{ __html: content }} />
                </section> : null}

                {videoUrl ? <section className="theory">
                    <div className='overyt'></div>
                    <VideoView
                        videoId={videoUrl}
                        className="video"
                        endHandler={() => setEnded(true)}
                        pauseHandler={() => console.log("paused")}
                        playHandler={() => console.log("play")}
                    />
                    <div className='loveryt'></div>
                </section> : null}

                {pdf ? <section className="theory pdf">
                    <PDFViewer pdf={pdf} />
                </section> : null}

            </Col>
            <Col span={24}>
                {ended ? <Row className={'botones theory'}>
                    <Col span={24}><Button key="submit" type="primary" onClick={() => handleAccept()} style={{ 'width': '90%' }} disabled={false}>{t(lang, 'accept')}</Button></Col>
                    <Col span={24}></Col>
                </Row> : null}
            </Col>
        </Row>
    );
};

export default Theory;
